import React from "react";

const Footer = () => {
  return (
    <div className="f-container">CopyRight @2024 All Rights are recervied</div>
  );
};

export default Footer;
